<template>
    <div :class="[
        'calendar__calendar',
        requestPending ? 'calendar__calendar--requestpending' : ''
    ]">
        <template v-if="requestPending">
            <div class="calendar__calendar_loading">
                <component-loading/>
            </div>
        </template>
        <div ref="calendar" class="calendar__calendar_table"></div>
        <calendar-calendar-dialog :item="selectedItem" v-if="dialogActive"/>
    </div>
</template>
<script>
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import CalendarCalendarDialog from '@/components/ebs/calendar/CalendarCalendarDialog'
import dayjs from 'dayjs'
import ComponentLoading from '@/components/default/shared/ComponentLoading'

export default {
  components: { ComponentLoading, CalendarCalendarDialog },
  name: 'calendar-calendar',
  data () {
    return {
      dialogActive: false,
      dialogData: {},
      calendar: '',
      selectedItem: {},
      requestPending: false
    }
  },
  props: {
    events: {
      type: [Array, Object, String]
    }
  },
  methods: {
    initializeStyling () {
      const button = document.getElementsByClassName('fc-today-button')[0]
      if (button) {
        button.classList.add('btn')
        button.classList.add('btn--small')
        button.classList.add('btn--default')
        button.classList.remove('fc-button')
        button.classList.remove('fc-button-primary')
        button.innerHTML = `<span>${document.getElementsByClassName('fc-today-button')[0].textContent}</span>`
      }
    },
    performGetReport () {
      return new Promise((resolve, reject) => {
        const calendarView = this.calendar.view
        const dateStart = dayjs(calendarView.activeStart).format('YYYY-MM-DD')
        const dateEnd = dayjs(calendarView.activeEnd).format('YYYY-MM-DD')

        this.getReportCalendar(dateStart, dateEnd).finally(() => {
          resolve()
        })
      })
    },
    switchDialog () {
      this.dialogActive = !this.dialogActive
    },
    updateDate (date) {
      this.calendar.gotoDate(date)
      this.initializeStyling()
    },
    updateEvents (events) {
      let sources = this.calendar.getEventSources()
      if (sources.length) {
        sources[0].remove()
      }
      this.calendar.addEventSource(events)
      this.calendar.refetchEvents()
    },
    getReportCalendar (dateStart, dateEnd) {
      return new Promise((resolve, reject) => {
        this.requestPending = true
        this.$store.dispatch('getReportCalendar', {
          dateStart,
          dateEnd
        }).then(response => {
          resolve(response)
          this.updateEvents(this.events)
        }).catch(error => {
          reject(error)
        }).finally(() => {
          this.requestPending = false
        })
      })
    }
  },
  mounted () {
    const self = this
    this.calendar = new Calendar(this.$refs.calendar, {
      events: this.events,
      plugins: [dayGridPlugin, timeGridPlugin, listPlugin],
      header: {
        left: 'prev,next,title,today',
        right: 'timeGridDay,timeGridWeek,dayGridMonth,listWeek,resourceTimelineYear'
      },
      eventLimit: 3,
      height: 'parent',
      buttonIcons: {
        prev: 'icon--leftarrow',
        next: 'icon--rightarrow'
      },
      slotEventOverlap: true,
      allDayText: 'All day',
      navLinks: true,
      nowIndicator: true,
      defaultView: 'dayGridMonth',
      firstDay: 1,
      buttonText: {
        today: this.$t('ebs.calendar.buttons.today')
      },
      eventTimeFormat: {
        hour: 'numeric',
        minute: '2-digit',
        meridiem: 'short'
      },
      views: {
        timeGridDay: {
          buttonText: this.$t('ebs.calendar.buttons.day'),
          columnHeaderFormat: { weekday: 'long', day: 'numeric' },
          titleFormat: { year: 'numeric', month: 'short', day: 'numeric' }
        },
        timeGridWeek: {
          buttonText: this.$t('ebs.calendar.buttons.week'),
          columnHeaderFormat: { weekday: 'short', day: 'numeric' }
        },
        dayGridMonth: {
          buttonText: this.$t('ebs.calendar.buttons.month'),
          columnHeaderFormat: { weekday: 'short' }
        },
        listWeek: {
          buttonText: this.$t('ebs.calendar.buttons.list')
        }
      },
      eventClick (info) {
        self.dialogActive = true
        self.selectedItem = info.event.extendedProps.event
      },
      datesRender () {
        self.performGetReport()
      }
    })

    this.calendar.render()
    this.initializeStyling()
  },
  updated () {
    this.initializeStyling()
  }
}
</script>
<style lang="scss">
    @import "~@/../node_modules/@fullcalendar/core/main.css";
    @import "~@/../node_modules/@fullcalendar/daygrid/main.css";
    @import "~@/../node_modules/@fullcalendar/timegrid/main.css";
    @import "~@/../node_modules/@fullcalendar/list/main.css";
    @import "~@/assets/scss/components/ebs/calendar/calendarcalendar";
</style>
